import * as React from "react"

function SvgFeatherArrowUpLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather-arrow-up-left_svg__feather feather-arrow-up-left_svg__feather-arrow-up-left"
      {...props}
    >
      <path d="M17 17L7 7M7 17V7h10" />
    </svg>
  )
}

export default SvgFeatherArrowUpLeft
